import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-088b5fda"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, null, -1))
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skyline-logo" }, null, -1))
const _hoisted_4 = { class: "flex items-center justify-center background-noise" }

import { useRouter } from 'vue-router';
import PasswordResetComponent from '../components/login/PasswordResetComponent.vue';
import { RouteNames } from '../router/Routes';
import { AuthClient } from '../services/auth';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordResetPage',
  setup(__props) {

const router = useRouter();
const submitMessage = ref('');
const successfulSubmissionResponse = 'Check your email for a reset link';
const failedSubmissionResponse = 'This email does not exist';
const errorOccured = ref(false);

function handleCancel() {
  router.push({ name: RouteNames.LOGIN });
}
async function handleSubmit(email: string) {
  try {
    await AuthClient.getInstance().sendPasswordResetEmail(email);
    errorOccured.value = false;
    submitMessage.value = successfulSubmissionResponse;
  } catch (err) {
    errorOccured.value = true;
    submitMessage.value = failedSubmissionResponse;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(PasswordResetComponent, {
          class: "z-10 w-1/4",
          "submit-message": submitMessage.value,
          error: errorOccured.value,
          onCancel: handleCancel,
          onSubmit: handleSubmit
        }, null, 8, ["submit-message", "error"])
      ])
    ])
  ], 64))
}
}

})